"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyAppend = void 0;
function applyAppend(factory, src, item) {
    function* generator() {
        for (const currentItem of src) {
            yield currentItem;
        }
        yield item;
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyAppend = applyAppend;
//# sourceMappingURL=applyAppend.js.map